module.exports = __webpack_public_path__ + "static/media/CoreA1_negativo.a6f9d8e5.png";